import { Link } from 'react-router-dom';
import type { ArticleItem } from '@/mocks/article';

interface ArticleCardProps {
  article: ArticleItem;
  variant?: 'horizontal' | 'vertical';
}

export default function ArticleCard({ article, variant = 'vertical' }: ArticleCardProps) {
  if (variant === 'horizontal') {
    return (
      <Link
        to={`/article/${article.slug}`}
        className="group flex gap-4 p-3 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
      >
        <div className="w-28 h-20 shrink-0 rounded-lg overflow-hidden bg-background-100">
          <img
            src={article.cover}
            alt={article.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
            {article.title}
          </h4>
          <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{article.excerpt}</p>
          <div className="flex items-center gap-2 mt-2">
            <span className="text-xs text-foreground-400">{article.publishDate}</span>
            <span className="text-xs text-foreground-400">·</span>
            <span className="text-xs text-foreground-400">{article.readTime}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[16/9] bg-background-100">
        <img
          src={article.cover}
          alt={article.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 rounded-md bg-secondary-800/80 text-secondary-100 text-xs">
            {article.tags[0]}
          </span>
        </div>
      </div>
      <div className="mt-3">
        <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
          {article.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="flex items-center gap-2 mt-2">
          <span className="text-xs text-foreground-400">{article.publishDate}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-400">{article.readTime}</span>
        </div>
      </div>
    </Link>
  );
}